export const TAX_RATE = 0.14975;
export const PERIODS = { monthly: 12, biweekly: 26, weekly: 52 };

export const payment = (principal, annualRate, months, freq = 'monthly') => {
  const ppy = PERIODS[freq];
  const n = Math.round((months / 12) * ppy);
  if (principal <= 0 || n <= 0) return { per: 0, total: 0, interest: 0 };
  const r = annualRate / 100 / ppy;
  const per = r === 0 ? principal / n : (principal * r) / (1 - Math.pow(1 + r, -n));
  const total = per * n;
  return { per, total, interest: total - principal };
};

export const money = (v, en, decimals = 2) =>
  new Intl.NumberFormat(en ? 'en-CA' : 'fr-CA', { style: 'currency', currency: 'CAD', minimumFractionDigits: decimals, maximumFractionDigits: decimals }).format(v || 0);
